import React from 'react';
import Swal from 'sweetalert2';
import {
  ShiftCourierJson,
  ShiftStatusType,
  ShiftCourierJsonForCourier,
} from '../../../const/ShiftConst';
import { createWishShiftAsync } from 'fetch/shiftFetch';
import { Dayjs } from 'dayjs';
import { COLOR } from 'const/color';
import { isDateWithin4weeksFromNow } from 'utils/date';

import './AddWishSpotButton.scss';

import { MdNotInterested } from 'react-icons/md';
import { updateShift } from '../WeekDayForCourier/WeekDayForCourier';
import analyticsWrapper from '../../../utils/analyticsWrapper';
import { Region } from '../../../types/orderTypes';

async function addWishShift(
  shiftCourierList: ShiftCourierJsonForCourier[],
  name: string,
  courierId: number,
  status: ShiftStatusType = ShiftStatusType.OPEN,
  date: Dayjs,
  setShiftCourierList: (param: any[]) => void,
  region: Region
) {
  const ShiftCourierResponse: ShiftCourierJson = await createWishShiftAsync(
    date,
    name,
    region
  );
  if (ShiftCourierResponse) {
    if (shiftCourierList && shiftCourierList.length > 0) {
      setShiftCourierList([
        ...shiftCourierList,
        {
          id: ShiftCourierResponse.id,
          name: name,
          courierId: courierId,
          note: '',
          status: status,
        },
      ]);
    } else {
      setShiftCourierList([
        {
          id: ShiftCourierResponse.id,
          name: name,
          courierId: courierId,
          note: '',
          status: status,
        },
      ]);
    }
  }
}

async function unRegisterWishShift(
  shiftCourierList: ShiftCourierJsonForCourier[],
  setShiftCourierList: (shiftCourierList: ShiftCourierJsonForCourier[]) => void,
  courierId: number,
  courierName: string,
  shiftCourier: ShiftCourierJsonForCourier
) {
  const status = ShiftStatusType.DELETED;

  const ShiftCourierListResponse: ShiftCourierJsonForCourier[] =
    await updateShift(
      shiftCourier,
      shiftCourierList,
      courierId,
      courierName,
      status
    );
  if (ShiftCourierListResponse) {
    setShiftCourierList(ShiftCourierListResponse);
    analyticsWrapper.event({
      category: 'shiftSystem',
      action: `unrequest wish shift`,
      label: 'courier',
    });
  } else {
    alert('there was a network error, try again');
  }
}

async function AddWishSpotModal(
  shiftCourierList: ShiftCourierJsonForCourier[],
  name: string,
  courierId: number,
  status: ShiftStatusType = ShiftStatusType.OPEN,
  date: Dayjs,
  setShiftCourierList: (param: any[]) => void,
  region: Region
) {
  Swal.fire({
    title: 'Sign up?',
    text: `Are you sure you ( ${name}) want to be put on the requested list for this shift? `,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes put me on the list',
    confirmButtonColor: COLOR.SHIFT_GREEN,
    cancelButtonColor: COLOR.PROGRESS_RED,
  })
    .then(async result => {
      if (result.value) {
        await addWishShift(
          shiftCourierList,
          name,
          courierId,
          status,
          date,
          setShiftCourierList,
          region
        );
        Swal.fire('Success!', `${name}  shift is requested `, 'success');
        analyticsWrapper.event({
          category: 'shiftSystem',
          action: `request wish shift`,
          label: 'courier',
        });
      } else {
        Swal.fire('You did not register for requested list!');
      }
    })
    .catch(error => console.error(error));
}

export const UnregisterWishSpotButton = ({
  shiftCourierList,
  setShiftCourierList,
  courierId,
  courierName,
  shiftCourier,
}: {
  shiftCourierList: ShiftCourierJsonForCourier[];
  setShiftCourierList: (shiftCourierList: ShiftCourierJsonForCourier[]) => void;
  courierId: number;
  courierName: string;
  shiftCourier: ShiftCourierJsonForCourier;
}): JSX.Element => {
  return (
    <>
      <div
        onClick={async () =>
          await unRegisterWishShift(
            shiftCourierList,
            setShiftCourierList,
            courierId,
            courierName,
            shiftCourier
          )
        }
        className="addWishSpotButtonSucess"
      >
        {'Registered request'}
        <div>{'(click to unregister)'}</div>
      </div>
    </>
  );
};

export const AddWishSpotButton = ({
  date,
  shiftCourierList,
  setShiftCourierList,
  courierName,
  courierId,
  disabled,
  region,
}: {
  date: Dayjs;
  shiftCourierList: ShiftCourierJsonForCourier[];
  setShiftCourierList: (param: ShiftCourierJsonForCourier[]) => void;
  courierName: string;
  courierId: number;
  disabled: boolean;
  region: Region;
}): JSX.Element => {
  const status: ShiftStatusType = ShiftStatusType.WISH;
  const isWithin2WeeksFromNow: boolean = isDateWithin4weeksFromNow(date);
  if (!isWithin2WeeksFromNow) {
    return <div className="addWishSpotButton"> Currently unavailable </div>;
  } else if (!disabled) {
    return (
      <div
        className="addWishSpotButton"
        onClick={async () =>
          await AddWishSpotModal(
            shiftCourierList,
            courierName,
            courierId,
            status,
            date,
            setShiftCourierList,
            region
          )
        }
      >
        + Click to register availability
      </div>
    );
  } else {
    return <></>;
  }
};

export function NotAvailableShift({
  date,
  shiftCourierList,
  setShiftCourierList,
  courierName,
  courierId,
  wishList,
  region,
}: {
  date: Dayjs;
  shiftCourierList: ShiftCourierJsonForCourier[];
  setShiftCourierList: (shiftCourierList: ShiftCourierJsonForCourier[]) => void;
  courierName: string;
  courierId: number;
  wishList: ShiftCourierJsonForCourier[];
  region: Region;
}): JSX.Element {
  return (
    <>
      <div className="NotAvailableShiftBox">
        <div
          style={{
            backgroundColor: COLOR.SHIFT_GRAY,
            color: COLOR.WHITE,
          }}
          className="courierNameBox"
        >
          <div className="addCourierBtn">
            <MdNotInterested /> Not available
          </div>
          <AddWishSpotButton
            date={date}
            shiftCourierList={shiftCourierList}
            setShiftCourierList={setShiftCourierList}
            courierName={courierName}
            courierId={courierId}
            disabled={wishList.length > 0}
            region={region}
          />
        </div>
      </div>
    </>
  );
}

export function NotAvailableShiftUnRegister({
  shiftCourierList,
  setShiftCourierList,
  courierId,
  courierName,
  shiftCourier,
}: {
  shiftCourierList: ShiftCourierJsonForCourier[];
  setShiftCourierList: (shiftCourierList: ShiftCourierJsonForCourier[]) => void;
  courierId: number;
  courierName: string;
  shiftCourier: ShiftCourierJsonForCourier;
}): JSX.Element {
  return (
    <>
      <div className="NotAvailableShiftBox">
        <div
          style={{
            backgroundColor: COLOR.SHIFT_GRAY,
            color: COLOR.WHITE,
          }}
          className="courierNameBox"
        >
          <div className="addCourierBtn">
            <MdNotInterested /> Not available
          </div>
          <UnregisterWishSpotButton
            shiftCourierList={shiftCourierList}
            setShiftCourierList={setShiftCourierList}
            courierId={courierId}
            courierName={courierName}
            shiftCourier={shiftCourier}
          />
        </div>
      </div>
    </>
  );
}
